define('commons/launch-coverage-button',['jquery', 'commons/loading-mask'], function ($, LoadingMask) {

    var LaunchCoverageButton = function(container, mapSelector, toolbarSelector, options) {
        var template = '<span class="icon" /><span class="label"></span>';
        this.$container = $(container);
        this.$container.html(template);
        this.$label = $(this.$container.find(".label")[0]);
        this.$icon = $(this.$container.find(".icon")[0]);
        var quickResetSelector = "#simu-quick-reset";
        this.$quickReset = $(quickResetSelector);
        this.quickResetLoadingMask = new LoadingMask(quickResetSelector, {
                    progress: false});
        this.loadingMask = new LoadingMask(mapSelector);
        this.toolsLoadingMasks = [];
       $(toolbarSelector).each( $.proxy(function (index, elem) {
            this.toolsLoadingMasks.push(new LoadingMask('#' + elem.id));
        }, this));
        this.updateState(options);
    };
    
    var hide = function (element) {
        element.hide();
    };
    
    var show = function (element) {
        element.show();
    };
    
    LaunchCoverageButton.prototype.updateState = function(data) {
        if (data.running) {
            this.running();
        } else if (data.hasEmptyCoverage) {
            this.incomplete();
        } else if (data.updated || data.hasDeleted) {
            this.updated();
        } else if (data.hasHiddenUpdated) {
            this.hiddenUpdated();
        } else {
            this.ok();
        }
    };
    
    LaunchCoverageButton.prototype._tooltip = function(tooltip) {
        this.$container.attr("title", tooltip);
    };
    
    LaunchCoverageButton.prototype._label = function(newLabel) {
        this.$label.text(newLabel);
    };
    
    LaunchCoverageButton.prototype._updateIcon = function(icon) {
        this.$icon.removeClass();
        this.$icon.addClass("icon");
        this.$icon.addClass(icon);
    };
    
    LaunchCoverageButton.prototype._disable = function() {
        this.$container.prop('disabled', true);
        this.$container.addClass("disabled");
        this.loadingMask.show();
        this.toolsLoadingMasks.forEach(show);
    };
    
    LaunchCoverageButton.prototype._enable = function() {
        this.$container.prop('disabled', false);
        this.$container.removeClass("disabled");
        this.loadingMask.hide();
        this.toolsLoadingMasks.forEach(hide);
    };

    LaunchCoverageButton.prototype._disableQuickReset = function(disable) {
        if (disable) {
           this.$quickReset.addClass("disabled");
           this.quickResetLoadingMask.show();
        } else {
           this.$quickReset.removeClass("disabled");
           this.quickResetLoadingMask.hide();
        }
    };
    
    LaunchCoverageButton.prototype.isEnabled = function() {
        return !this.$container.prop("disabled");
    };
    
    LaunchCoverageButton.prototype.isRunning = function() {
        return this.$icon.hasClass(this.Icons.RUNNING);
    };

    LaunchCoverageButton.prototype.isQuickResetEnabled = function() {
        return !this.$quickReset.hasClass("disabled");
    };
    
    LaunchCoverageButton.prototype.incomplete = function() {
        this._enable();
        this._label("Launch");
        this._updateIcon(this.Icons.INCOMPLETE);
        this._tooltip("Relaunch to complete the coverage");
        this._disableQuickReset(true);
    };
    
    LaunchCoverageButton.prototype.hiddenUpdated = function() {
        this._enable();
        this._label("Launch");
        this._updateIcon(this.Icons.HIDDEN_UPDATED);
        this._tooltip("Display all the spots coverages to see the full coverage");
        this._disableQuickReset(false);
    };
    
    LaunchCoverageButton.prototype.updated = function() {
        this._enable();
        this._label("Launch");
        this._updateIcon(this.Icons.UPDATED);
        this._tooltip("Relaunch to update the coverage");
        this._disableQuickReset(true);
    };
    
    LaunchCoverageButton.prototype.ok = function() {
        this._enable();
        this._label("Launch");
        this._updateIcon(this.Icons.OK);
        this._tooltip("");
        this._disableQuickReset(false);
    };
    
    LaunchCoverageButton.prototype.running = function() {
        this._disable();
        this._label("Running...");
        this._updateIcon(this.Icons.RUNNING);
        this._tooltip("Please wait while processing the coverage");
        this._disableQuickReset(true);
    };
    
    LaunchCoverageButton.prototype.disable = function() {
        this._disable();
        this._label("Launch");
        this._updateIcon(this.Icons.OK);
        this._tooltip("Select an area first");
        this._disableQuickReset(true);
    };
    
    LaunchCoverageButton.prototype.click = function(callback) {
        this.$container.click(callback);
    };
    
    LaunchCoverageButton.prototype.Icons = {
        OK : "icon-ok icon-large",
        UPDATED : "icon-refresh icon-large",
        INCOMPLETE: "icon-question icon-large",
        HIDDEN_UPDATED: "icon-asterisk icon-large",
        RUNNING: "icon-refresh icon-spin icon-large"
    };
    
    return LaunchCoverageButton;
});
